import React, { useRef, useCallback } from 'react';
import { Form } from 'reactiverecord';
import PropTypes from 'prop-types';

/* This form submits when the given `change` function is called or if the user hits [Return] on a text field */
const AutoSubmittingForm = ({ onChange, children, ...props }) => {
  const formRef = useRef(null);
  const change = useCallback(
    event => {
      if (onChange) {
        onChange(event);
        if (event.defaultPrevented) {
          return;
        }
      }
      formRef.current.submit();
    },
    [onChange],
  );
  return (
    <Form ref={formRef} {...props}>
      {fields => (
        <>
          {children(fields, change)}
          <button
            data-id="auto-submit-form-btn"
            {...fields.submit}
            css={`
              display: none;
            `}
          />
        </>
      )}
    </Form>
  );
};

AutoSubmittingForm.propTypes = {
  children: PropTypes.func.isRequired,
  onChange: PropTypes.func,
};

export default AutoSubmittingForm;
